export default function bodyCountMapping(val) {
    if (window.business) {
        switch (val) {
            case 1:
                return 8000;
            case 2:
                return 10000;
            case 3:
                return 12000;
            case 4:
                return 14000;
        }
    }
    else if (window.waermepumpe) {
        switch (val) {
            case 1:
                return 2750;
            case 2:
                return 5500;
            case 3:
                return 7500;
            case 4:
                return 11000;
        }
    }
    else {
        switch (val) {
            case 1:
                return 1200;
            case 2:
                return 1800;
            case 3:
                return 2200;
            case 4:
                return 3000;
        }
    }
    return 2200;
}
